import { render } from "./TransportCourierDeliveryBanner.vue?vue&type=template&id=db950624&scoped=true"
import script from "./TransportCourierDeliveryBanner.vue?vue&type=script&lang=js"
export * from "./TransportCourierDeliveryBanner.vue?vue&type=script&lang=js"

import "./TransportCourierDeliveryBanner.vue?vue&type=style&index=0&id=db950624&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db950624"]])

export default __exports__